var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Link as MuiLink, styled } from '@mui/material';
var LinkRoot = styled(MuiLink)(function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return (__assign({}, (disabled && {
        color: theme.palette.text.disabled,
    })));
});
var Link = React.forwardRef(function (_a, ref) {
    var text = _a.text, disabled = _a.disabled, hrefProp = _a.href, childrenProp = _a.children, LinkProps = __rest(_a, ["text", "disabled", "href", "children"]);
    var _b = React.useState(''), href = _b[0], setHref = _b[1];
    React.useEffect(function () {
        setHref(disabled ? undefined : hrefProp);
    }, [hrefProp, disabled]);
    var children = childrenProp;
    if (children == null) {
        children = text;
    }
    return (React.createElement(LinkRoot, __assign({ ref: ref, href: href, disabled: disabled }, LinkProps), children));
});
Link.defaultProps = {
    color: 'text.link',
    fontSize: 14,
    underline: 'none'
};
export default Link;
